import { Button, Loading } from '@wfp/react';
import { saveAs } from 'file-saver';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { apiCallAsync } from 'src/redux/api/saga';
import {
  EXPORT_ACR_DASHBOARD_KEY,
  REPORT_LIST_DATA_KEY,
} from 'src/redux/constants';
import type { RootState } from 'src/redux/store';
import { getActionAPISource } from 'src/utils';
import { showNotification } from 'src/utils';

interface Props {
  period?: string;
  dashboard_type?: string;
}

export function HeaderExportButton(props: Readonly<Props>) {
  const [loading, setLoading] = useState(false);

  function downloadFile() {
    let url = getActionAPISource(EXPORT_ACR_DASHBOARD_KEY);
    const params: Record<string, string> = {
      _period_: props.period ? props.period : 'current',
      _dashboard_type_: props.dashboard_type ? props.dashboard_type : 'project',
    };
    for (const [key, value] of Object.entries(params)) {
      url = url.replace(new RegExp(key, 'g'), value);
    }

    setLoading(true);

    apiCallAsync(url, params, 'get', 'blob').then(response => {
      const fileName = `acr-dashboard-${props.dashboard_type}-${props.period}.xls`;
      const options = { type: response.headers['content-type'] };
      const file = new Blob([response.data], options);
      saveAs(file, fileName);
      showNotification('File downloaded!', 'success');
      setLoading(false);
    });
  }

  return (
    <div className="acr-dashboard-button">
      {loading ? (
        <Button className="loading-tables-generation" disabled>
          <Loading className="wfp--loading--small" withOverlay={false} active />
          <div>Exporting in Excel</div>
        </Button>
      ) : (
        <Button
          className="btn btn-default"
          onClick={downloadFile}
          disabled={loading}
          data-test-id="export-in-excel-button"
        >
          Export in Excel
        </Button>
      )}
    </div>
  );
}

export const mapStateToProps = (state: RootState) => {
  try {
    return {
      ...state.viewData[REPORT_LIST_DATA_KEY].request_params.data,
    };
  } catch {
    return {
      dashboard_type: 'project',
      period: '',
    };
  }
};

export default connect(mapStateToProps)(HeaderExportButton);
